var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-goods-qr-code-detail',{staticClass:"pt-goods-qr-code-detail__withData",attrs:{"id":_vm.id,"revieQrCodeUrl":_vm.revieQrCodeUrl},on:{"downloadQrCodeDetail":_vm.downloadQrCodeDetail,"getQrCodeUrl":_vm.getQrCodeUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }